import { functions } from 'helpers';

import * as ErrorMessages from './errorMessages';

export const required = (text: any) => {
  return text ? null : ErrorMessages.isRequired;
};

export const requiredSelect = (value: any) => {
  if (value && value !== 'not-selected') {
    return null;
  }

  return ErrorMessages.isRequired;
};

export const ruleIfValue = (field: any, value: any, ruleRun: any) => {
  return (text: any, state: any) => {
    if (state[field] === value) {
      return ruleRun(text);
    }
    return null;
  };
};

export const ruleIfNotValue = (field: any, value: any, ruleRun: any) => {
  return (text: any, state: any) => {
    if (state[field] !== value) {
      return ruleRun(text);
    }
    return null;
  };
};

export const ruleIfInArray = (field: any, value: Array<number | string>, ruleRun: any) => {
  return (text: any, state: any) => {
    if (state[field] && value && value.indexOf(state[field]) !== -1) {
      return ruleRun(text);
    }
    return null;
  };
};

export const mustMatch = (field: any, fieldName: any) => {
  return (text: any, state: any) => {
    return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
  };
};

// só roda a regra se o campo correspondente for true
export const ruleIf = (fieldTrue: any, ruleRun: any) => {
  return (text: any, state: any) => {
    if (state && state[fieldTrue]) {
      return ruleRun(text);
    }
    return null;
  };
};

// só roda a regra se o campo correspondente for true
export const ruleIfEquals = (field: any, value: any, ruleRun: any) => {
  return (text: any, state: any) => {
    if (state[field] === value) {
      return ruleRun(text);
    }
    return null;
  };
};

export const ruleIfEqualsAND = (fields: any[], ruleRun: any) => {
  return (text: any, state: any) => {
    let isValid = true;
    fields.forEach((f: any) => {
      if (isValid) {
        isValid = state[f.field] === f.value;
      }
    });
    return isValid ? ruleRun(text) : null;
  };
};

export const minLength = (length: any) => {
  return (text: any) => {
    return text && text.length >= length ? null : ErrorMessages.minLength(length);
  };
};

export const maxLength = (length: any) => {
  return (text: any) => {
    return text && text.length > length ? ErrorMessages.maxLength(length) : null;
  };
};

export const plainText = (length: number) => {
  return (text: string) => {
    const newText = text
      ?.replace(/<\/?[a-z][a-z0-9]*[^<>]*>/gi, '')
      .replace(/(&nbsp;|&nbsp;&nbsp;)/g, ' ')
      .replace(/&gt;/g, '<')
      .replace(/&lt;/g, '>')
      .replace(/&amp;/g, '&');
    return newText && newText.length > length ? ErrorMessages.maxLength(length) : null;
  };
};

export const arrayMinLength = (length: any) => {
  return (array: any) => {
    return Array.isArray(array) && array.length >= length ? null : ErrorMessages.arrayMinLength(length);
  };
};

export const arrayMaxLength = (length: any) => {
  return (array: any) => {
    return Array.isArray(array) && array.length <= length ? null : ErrorMessages.arrayMaxLength(length);
  };
};

export const isEmail = (text: any) => {
  // eslint-disable-next-line max-len
  const regexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let email = text ? regexp.test(String(text).toLowerCase()) : true;
  return email ? null : ErrorMessages.isEmail();
};

export const isUrl = (text: any) => {
  // eslint-disable-next-line max-len
  const regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  let url = text ? regexp.test(String(text).toLowerCase()) : true;
  return url ? null : ErrorMessages.isUrl();
};

export const isSunUrl = (text: string) => {
  const hasInvalidUrl = text.includes('sun.eduzz.com') || text.includes('chk.eduzz.com');
  return hasInvalidUrl ? ErrorMessages.isSunUrl() : null;
};

export const minimun = (min: any) => {
  return (val: any) => {
    if (!val) {
      return ErrorMessages.minimun(min);
    }
    if (Number(val)) {
      const isGreaterOrEqual = Number(val) >= Number(functions.clearMoneyMask(min));
      return isGreaterOrEqual ? null : ErrorMessages.minimun(min);
    }
    const isGreaterOrEqual = Number(functions.clearMoneyMask(val)) >= Number(functions.clearMoneyMask(min));
    return isGreaterOrEqual ? null : ErrorMessages.minimun(min);
  };
};
export const maximum = (max: any) => {
  return (val: any) => {
    if (!val) {
      return ErrorMessages.maximum(max);
    }
    if (Number(val)) {
      return val <= max ? null : ErrorMessages.maximum(max);
    }
    const isLowerOrEqual = Number(functions.clearMoneyMask(val)) <= Number(functions.clearMoneyMask(max));
    return isLowerOrEqual ? null : ErrorMessages.maximum(max);
  };
};
export const lunhCheck = (cardNumber: string) => {
  if (cardNumber.length === 0) {
    return false;
  }

  const isValid =
    cardNumber
      .replace(/\s/g, '')
      .split('')
      .reverse()
      .map((x) => parseInt(x, 10))
      .map((x, idx) => (idx % 2 ? x * 2 : x))
      .map((x) => (x > 9 ? (x % 10) + 1 : x))
      .reduce((accum, x) => (accum += x)) %
      10 ===
    0;

  return isValid ? null : ErrorMessages.lunhCheck();
};

export const hasNoValue = (field: any, value: any, ruleRun: any) => {
  return (text: any, state: any) => {
    return state[field] && state[field] === value ? null : ruleRun(text);
  };
};
